export default {
  collapsedItems: []
}
